export const PictureVendorDCP = [
    'Film_Title',
    'UCCID',
    'Language',
    'MKV RESOLUTION',
    'SOURCE DPX',
    'Bit Depth',
    'SOURC DPX COLOR SPACE',
    "Film Gauge",
    "Total Reels",
    'Director',
    'Type',
    'Resolution',
    'Aspect Ratio',
]

// export const TimeAndDateFFV1 = [
//     'DURATION',
//     'FRAME COUNT OF DSM',
//     'SIZING AND FRAMING DONE',
//     'MKV GENERATED USING RAWCOOKED',
//     'MKV REVERSIBILITY CHECK (to be verified through CML)',
//     'MKV STREAM FORMATION',
//     'AUDIO PRESENT IN MKV',
//     'RESTORED AUDIO FORMAT - Cinemix 48kHz',
//     'PEFORATIONS VISIBLE',
//     'FILE CREATION DATE',
// ]

export const LTO_Frist_Json: string[] = [
  "Film_Title",
  "UCCID",
  "Language",
  "Resolution",
  "Film Type",
  "Bit Depth",
  "SOURCE DPX COLOR SPACE",
  "Film Gauge",
  "SOURCE AUDIO FORMAT",
  "Total Reels",
  "Duration (Synced Title in Mints)",
  "PICTURE RESTORATION VENDOR NAME",
  "AUDIO RESTORATION VENDOR NAME",
  "LTO CREATION DATE",
  "LTO CLONE CREATION DATE",
  "Director",
  "Film_Year",
  "Type",
  "Aspect Ratio",
];


export const labels = {
  Film_Title: 'PROJECT TITLE',
  UCCID: 'PROJECT ID/CODE',
  'Total Reels':"NO. OF REELS",
  "Film Gauge":"SOURCE DPX ORIGIN",
  "Film_Year": 'Year of Release/Production',
  "Film Type":"SOURCE DPX",
  "Aspect Ratio" : "IMAGE ASPECT RATIO****"
}

  //  export const cleanData = (arr:any) => {

  //   // 1. group by elementName
  //   const groups:any = {};
  //   arr.forEach((o:any) => {
  //       (groups[o.elementName] ||= []).push(o);
  //   });

  //   // 2. filter inside every group
  //   const out:any[] = [];
  //   Object.values(groups).forEach((g:any) => {
  //       const nonEmpty = g.filter((o:any) => o.elementValue !== "");
  //       if (nonEmpty.length) out.push(...nonEmpty);   // keep non-empty duplicates
  //       // if all were empty we simply push nothing → they disappear
  //   });
  //   return out;
  //   }

 export const getFirstSubtaskIdByName = (workflow: any, subtaskName: string): string => {
    if (!workflow) return "";

    const tasks = Array.isArray(workflow) ? workflow : (workflow.tasks || []);
    for (const t of tasks) {
      const subs = t.subTasks || []; // note: "subTasks" matches your JSON
      for (const s of subs) {
        if (s?.subTaskName && s.subTaskName.toLowerCase() === subtaskName.toLowerCase()) {
          return s.subTaskId || "";
        }
      }
    }
    return "";
  };